enum CacheTag {
  Subscription = 'Subscription',
  SubscriptionLines = 'SubscriptionLines',
  ServiceLevelDefinition = 'ServiceLevelDefinition',
  ServiceLevelDefinitionNsbSetup = 'ServiceLevelDefinitionNsbSetup',
  ServiceLevelDefinitionNsb = 'ServiceLevelDefinitionNsb',
  SubscriptionPlanClassifier = 'SubscriptionPlanClassifier',
  Nsb = 'Nsb',
  ListCustomSubscriptionConfigurations = 'ListCustomSubscriptionConfigurations',
  GetCustomSubscriptionConfiguration = 'GetCustomSubscriptionConfiguration',
}

export default CacheTag;
